import { render, staticRenderFns } from "./NavbarBlock.vue?vue&type=template&id=0537a96b&scoped=true&"
var script = {}
import style0 from "./NavbarBlock.vue?vue&type=style&index=0&id=0537a96b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0537a96b",
  null
  
)

export default component.exports